import React from 'react';
import { Phone, CheckCircle, DollarSign, Clock } from 'lucide-react';
export function FleetMaintenancePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5975">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5976">
        <div className="container mx-auto px-4" data-id="element-5977">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5978">
            Maximize Your Up Time and Minimize Repair Costs
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-5979">
            Professional Fleet Maintenance and Repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5980">
        <div className="max-w-4xl mx-auto" data-id="element-5981">
          {/* Hero Image */}
          <div className="mb-8" data-id="element-5982">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/preview/uploaded/images/towing.jpg?opt=w3" alt="Fleet maintenance and towing services" className="w-full h-auto rounded-lg shadow-md" data-id="element-5983" />
          </div>

          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5984">
            <p className="text-lg text-gray-700 mb-6" data-id="element-5985">
              <strong data-id="element-5986">
                The staff at Garrett Auto & Truck Service knows how important
                your time is
              </strong>
              , and how difficult it can be to stay on top of maintenance
              schedules when you are busy running your business.
            </p>

            <p className="text-lg text-gray-700" data-id="element-5987">
              We offer a Fleet Maintenance Program that takes all the hassle of
              keeping your fleet up and running off your plate – whether you
              have one truck or fifty. We'll design, implement and administer
              maintenance and repair program for your entire fleet, helping you
              keep breakdowns and hassle to a minimum.
            </p>
          </div>

          {/* Cost Comparison */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5988">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-5989">
              Real Cost Comparison
            </h2>

            <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-5990">
              Let's look at the costs for complete maintenance (oil change, oil
              filter, chassis lube & safety inspection) for a 2004 Ford F600/800
              with a 5.9 liter Cummins engine:
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-5991">
              {/* Dealer Cost */}
              <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6" data-id="element-5992">
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-5993">
                  Truck/Engine Dealer Shop
                </h3>

                <div className="text-center mb-4" data-id="element-5994">
                  <div className="text-4xl font-bold text-red-600 mb-2" data-id="element-5995">
                    $365.13
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-5996">Base Service Cost</p>
                </div>

                <div className="space-y-3 text-gray-700" data-id="element-5997">
                  <div className="flex items-start" data-id="element-5998">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-5999">
                      ✗
                    </span>
                    <span data-id="element-6000">Lost man-hours while driver waits</span>
                  </div>
                  <div className="flex items-start" data-id="element-6001">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6002">
                      ✗
                    </span>
                    <span data-id="element-6003">Time and hassle handling paperwork</span>
                  </div>
                  <div className="flex items-start" data-id="element-6004">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6005">
                      ✗
                    </span>
                    <span data-id="element-6006">Keeping track of schedule yourself</span>
                  </div>
                  <div className="flex items-start" data-id="element-6007">
                    <span className="text-red-600 mr-2 flex-shrink-0 mt-1" data-id="element-6008">
                      ✗
                    </span>
                    <span data-id="element-6009">Higher overhead costs</span>
                  </div>
                </div>
              </div>

              {/* Garrett Auto Cost */}
              <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 relative" data-id="element-6010">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-600 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-6011">
                  BEST VALUE
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-6012">
                  Garrett Auto & Truck
                </h3>

                <div className="text-center mb-4" data-id="element-6013">
                  <div className="text-4xl font-bold text-green-600 mb-2" data-id="element-6014">
                    $265.11
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-6015">
                    Complete Service Package
                  </p>
                </div>

                <div className="space-y-3 text-gray-700" data-id="element-6016">
                  <div className="flex items-start" data-id="element-6017">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6018" />
                    <span data-id="element-6019">Convenient scheduling options</span>
                  </div>
                  <div className="flex items-start" data-id="element-6020">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6021" />
                    <span data-id="element-6022">Minimize downtime</span>
                  </div>
                  <div className="flex items-start" data-id="element-6023">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6024" />
                    <span data-id="element-6025">We handle all paperwork</span>
                  </div>
                  <div className="flex items-start" data-id="element-6026">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={18} data-id="element-6027" />
                    <span data-id="element-6028">We track your maintenance schedule</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Savings Highlight */}
            <div className="mt-8 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg p-6 text-center" data-id="element-6029">
              <div className="flex items-center justify-center mb-2" data-id="element-6030">
                <DollarSign size={32} className="mr-2" data-id="element-6031" />
                <span className="text-3xl font-bold" data-id="element-6032">
                  Save $100.02 Per Service
                </span>
              </div>
              <p className="text-green-100 text-lg" data-id="element-6033">
                Plus eliminate lost productivity and administrative hassle
              </p>
            </div>
          </div>

          {/* Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6034">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6035">
              Why Choose Garrett Auto & Truck?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6036">
              <div className="text-center" data-id="element-6037">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6038">
                  <DollarSign className="text-blue-600" size={32} data-id="element-6039" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6040">
                  Lower Costs
                </h3>
                <p className="text-gray-700" data-id="element-6041">
                  Save over $100 per service compared to dealer prices
                </p>
              </div>

              <div className="text-center" data-id="element-6042">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6043">
                  <Clock className="text-green-600" size={32} data-id="element-6044" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6045">
                  Save Time
                </h3>
                <p className="text-gray-700" data-id="element-6046">
                  Convenient scheduling means minimal disruption to your
                  operations
                </p>
              </div>

              <div className="text-center" data-id="element-6047">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6048">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-6049" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6050">
                  Full Service
                </h3>
                <p className="text-gray-700" data-id="element-6051">
                  We handle scheduling, paperwork, and maintenance tracking
                </p>
              </div>
            </div>
          </div>

          {/* Fleet Size Options */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6052">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6053">
              Fleet Maintenance for Any Size Operation
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-6054">
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-6055">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6056">
                  Small Fleets (1-5 Vehicles)
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-6057">
                  <li className="flex items-start" data-id="element-6058">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6059" />
                    <span data-id="element-6060">Personalized service and attention</span>
                  </li>
                  <li className="flex items-start" data-id="element-6061">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6062" />
                    <span data-id="element-6063">Flexible scheduling around your needs</span>
                  </li>
                  <li className="flex items-start" data-id="element-6064">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6065" />
                    <span data-id="element-6066">Direct communication with technicians</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-6067">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6068">
                  Large Fleets (5+ Vehicles)
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-6069">
                  <li className="flex items-start" data-id="element-6070">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6071" />
                    <span data-id="element-6072">Dedicated fleet coordinator</span>
                  </li>
                  <li className="flex items-start" data-id="element-6073">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6074" />
                    <span data-id="element-6075">Volume pricing and discounts</span>
                  </li>
                  <li className="flex items-start" data-id="element-6076">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6077" />
                    <span data-id="element-6078">Comprehensive reporting and analytics</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6079">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6080">
              Start Saving on Fleet Maintenance Today
            </h2>
            <p className="text-xl mb-6" data-id="element-6081">
              Get a custom fleet maintenance plan designed for your business
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6082">
              <Phone className="mr-3" size={24} data-id="element-6083" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6084">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}